<div class="bg-image"></div>

<div class="wrapper sticky">
  <nav class="navbar-fixed-top">
    <a href="#" class="logo">
      <mat-icon>storefront</mat-icon> Cafeteria Management System
    </a>
    <ul>
      <li><a (click)="loginAction()">Login</a></li>
      <li><a (click)="signupAction()">Signup</a></li>
      <li><a (click)="forgotPasswordAction()">Forgot Password?</a></li>
    </ul>
  </nav>
</div>